import React, { useEffect, useState, useRef } from "react";
import L, { featureGroup } from "leaflet";
import "leaflet/dist/leaflet.css";
import "./mapa.css";
import Info from './info';  // Importa el componente Info
import Legend from "./legend";
import {InfoEstadoDataType, EstadoValueDataType, InfoMunicipioDataType} from "./DataType";
import { relative } from "path";
import MapLink from "./buttonMap";


const API_URL = process.env.REACT_APP_API_URL

// Define the component
const MexicoMap: React.FC = () => {
  const [valuesData, setValuesData] = useState<EstadoValueDataType[] | null>(null);  
  const [municipiosData, setMapaMunicipiosData] = useState<any>();
  const [estadosData, setMapaEstadosData] = useState<any>();
  const [infoData, setInfoData] = useState<InfoEstadoDataType | null>(null);
  const [title, setTitle] = useState('Mapa de todas las entrevistas realizadas');

  const mapRef = useRef<L.Map | L.LayerGroup<any>>();
  const estadosLayerRef = useRef<L.GeoJSON | null>(null);
  const municipiosLayerRef = useRef<L.GeoJSON | null>(null);
  const infoBox = useRef<L.Control | null>(null);
  let lastFeatureRef = useRef(null);
  

  const getMapaMexico = async () => {
    try {
      //const response = await fetch(`${API_URL}/dashboard/mapaEntrevistasEMI?emi=EMI3`);
      const response = await fetch(`${API_URL}/dashboard/mapaEntrevistas`);
      //const response = await fetch('datos.json');
      if (!response.ok) {
        throw Error(response.statusText);
      }
      const data = await response.json();

      var totalEntrevistas = data.reduce((sum : any, value : any) => (typeof value.cantidad == "number" ? sum + value.cantidad : sum), 0);
      setTitle(title + ' [' + totalEntrevistas + ']')
      setValuesData(data);
    } catch (err) {
      console.log(err);
    };
  }

  const getColor = (d: number) => {
    return d > 85 ? '#800026' :
      d > 72 ? '#BD0026' :
        d > 58 ? '#E31A1C' :
          d > 42 ? '#FC4E2A' :
            d > 28 ? '#FD8D3C' :
              d > 14 ? '#FEB24C' :
                d > 1 ? '#FED976' : '#FFEDA0';
  }

  const styleMapaEstados = (feature : any) =>{
    const foundValue = valuesData?.find(item => item.idEstado === parseInt(feature.properties.CVE_ENT));    
    const color = foundValue ? getColor(foundValue.cantidad) : '#FFFFFF';
    return {
			weight: 2,
			opacity: 1,
			color: 'white',
			dashArray: '3',
			fillOpacity: 0.7,
			fillColor:  color
    };
  }

  const highlightFeatureEstados = (e : any) => {    
    const layer = e.target;
    layer.setStyle({
      weight: 5,
      color: getColor(90),
      dashArray: '',
      fillOpacity: 0.7
    });

    layer.bringToFront();
  }

  const resetHighlightEstados = (e : any) => {
    if(estadosLayerRef.current)
		estadosLayerRef.current.resetStyle(e.target);
		//info.update();
	}

  const clickToFeatureEstados = (e: any) => {    
    if(lastFeatureRef.current)
        resetHighlightEstados(lastFeatureRef.current)
    //map.fitBounds(e.target.getBounds());
    highlightFeatureEstados(e)
    showMunicipios(e.target.feature.properties.CVE_ENT);
    lastFeatureRef.current = e;      
  }
  
  const onEachFeatureEstados = (feature : any, layer : any) => {
		layer.on({
			//mouseover: highlightFeatureEstados,
			//mouseout: resetHighlightFeatureEstados,
      click: clickToFeatureEstados			
		});
	}

  const styleMapaMunicipios = () =>{
    return {
      fillColor: 'green',
      fillOpacity: 0.5,
      weight: 2,
      color: 'green'
    }
  }

  const onEachFeatureMunicipios = (feature : any, layer : any) =>{    
      layer.on('mouseover', function() {
        const foundValue = valuesData?.find(item => item.idEstado === parseInt(feature.properties.CVE_ENT));        
          layer.bindPopup(feature.properties.NOMGEO + " : " + foundValue?.municipios.filter((el : any) => el.idMunicipio === parseInt(feature.properties.CVE_MUN))[0].cantidad).openPopup();
      });
      
      layer.on('mouseout', function() {
          layer.closePopup();
      });
  }

  const showMunicipios = (cve_ent : string) => {
    if (municipiosLayerRef.current) {
        municipiosLayerRef.current.remove();
    }
    
    const foundValue = valuesData?.find(item => item.idEstado === parseInt(cve_ent));    
    
    if (foundValue && mapRef.current) {        
        const municipios = foundValue.municipios.map(item => item.idMunicipio)
                .filter(value => typeof value === 'number')
                .map(id => id.toString().padStart(3, '0'));  
        municipiosLayerRef.current = L.geoJson(municipiosData, {
        filter : (feature) => feature.properties.CVE_ENT === cve_ent  && municipios.includes(feature.properties.CVE_MUN),
        style : styleMapaMunicipios,
        onEachFeature : onEachFeatureMunicipios
        
      }).addTo(mapRef.current);
      municipiosLayerRef.current.bringToFront();
    }
    
    if (foundValue) {
      const estado = estadosData.features.find((x : any) => x.properties.CVE_ENT === cve_ent)

      const infoMunicipios: InfoMunicipioDataType[] = foundValue.municipios.map(municipio => ({
        ...municipio,
        nombre: !municipio.idMunicipio  ? 'Sin municipio' : municipiosData.features.find((x : any) => x.properties.CVE_ENT.toString().padStart(2,'0') === cve_ent && x.properties.CVE_MUN === municipio.idMunicipio.toString().padStart(3,'0')).properties.NOMGEO,
      }));
  
      const infoEstado : InfoEstadoDataType = {
        nombre: estado.properties.NOMGEO,
        idEstado: foundValue.idEstado,
        cantidad: foundValue.cantidad,
        municipios : infoMunicipios
      };
      setInfoData(infoEstado)
    }
    else{
      const infoEstadoInicial: InfoEstadoDataType = {
        nombre: '',
        idEstado: 0,
        cantidad: 0,
        municipios: [],
      };  
      setInfoData(infoEstadoInicial);
    }
  }

  const updateTitle = (newTitle: string) => {
    setTitle(newTitle);
  };
  
  useEffect(() => {
    getMapaMexico();
  }, []);

  useEffect(() => {
        // Load estados.json for states
        fetch('municipios.json')
        .then(response => response.json())
        .then(data => {
          setMapaMunicipiosData(data);  // Set data to state          
          //municipiosLayerRef.current?.bringToBack()
      });  

  }, []);
  
  useEffect(() => {

    // Create a map centered on Mexico
    mapRef.current = L.map("map").setView([23.634501, -102.552734], 5);
    

    // Add a tile layer to the map
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      maxZoom: 19,
      attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(mapRef.current);

    
  
    fetch('mapa_mexico.json')
      .then(response => response.json())
      .then(data => {
        setMapaEstadosData(data);  // Set data to state
        if(valuesData !== null) {
          if(mapRef.current)
          {  // Check if valuesData is loaded
            estadosLayerRef.current = L.geoJson(data, {
              style: styleMapaEstados,
              onEachFeature : onEachFeatureEstados
            }).addTo(mapRef.current);                
          }
        }
      });
      
    const infoEstadoInicial: InfoEstadoDataType = {
      nombre: '',
      idEstado: 0,
      cantidad: 0,
      municipios: [],
    };  
    setInfoData(infoEstadoInicial);
      // Lógica para manipular el mapa aquí...
    return () => {
      if (mapRef.current) {
        mapRef.current.remove();  //Limpieza
      }      
    };

   
  }, [valuesData, municipiosData]);

  return (
    <div className="card h-d-m100">
      <div className="card-header align-items-center border-0">
        <div className="card-title">
          <h3 className="fw-bold text-gray-900 m-0">
            <span className="card-label fw-bold text-gray-900">{title}</span>
            <span className="text-gray-700 mt-1 fw-semibold fs-6">Solo los registros de entrevistas que tienen información de localización son contabilizados</span>
          </h3>
        </div>
        <div className="card-toolbar"> 
        {mapRef.current instanceof L.Map && (
          <React.Fragment>
            <MapLink map={mapRef.current} dataUrl={`${API_URL}/dashboard/mapaEntrevistasEmi?emi=EMI1`} updateMapData={setValuesData} title={'EMI 1'} updateMapTitle={setTitle} legend="Mapa Entrevistas EMI 1"/>
            <MapLink map={mapRef.current} dataUrl={`${API_URL}/dashboard/mapaEntrevistasEmi?emi=EMI2`} updateMapData={setValuesData} title={'EMI 2'} updateMapTitle={setTitle} legend="Mapa Entrevistas EMI 2"/>
            <MapLink map={mapRef.current} dataUrl={`${API_URL}/dashboard/mapaEntrevistasEmi?emi=EMI3`} updateMapData={setValuesData} title={'EMI 3'} updateMapTitle={setTitle} legend="Mapa Entrevistas EMI 3"/>
            <MapLink map={mapRef.current} dataUrl={`${API_URL}/dashboard/mapaEntrevistasEmi?emi=EMI5`} updateMapData={setValuesData} title={'EMI 5'} updateMapTitle={setTitle} legend="Mapa Entrevistas EMI 5"/>
            <MapLink map={mapRef.current} dataUrl={`${API_URL}/dashboard/mapaEntrevistas`} updateMapData={setValuesData} title={'Todos'} updateMapTitle={setTitle} legend="Mapa de todas las entrevistas realizadas"/>
          </React.Fragment>
        )}            
        </div>
      </div>
      <div className="card-body pt-2">
      <div id="map" style={{ width: "100%", height: "500px"}}>
        {mapRef.current instanceof L.Map && infoData && (
          <React.Fragment>
            <Info info={infoData} />
           {/* <Info map={mapRef.current} info={infoData} />*/}
           <Legend map={mapRef.current} />
          </React.Fragment>
        )}
        </div>
      </div>
    </div>
  );
};
export default MexicoMap;